import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BgFx, SvgDefs } from './BgFx';
import { CtaBanner } from './CtaBanner';
import { DemoModal } from './DemoModal';
import { FaqSection } from './FaqSection';
import { FeaturesSection, Marquee } from './FeaturesSection';
import { Footer } from './Footer';
import { HeroSection } from './HeroSection';
import { LiveTrackingShowcase } from './LiveTrackingShowcase';
import { Navbar } from './Navbar';
import { RoiCalculator } from './RoiCalculator';
import { CompareSection, HowItWorks, SolutionsSection } from './SolutionsSection';
import { TestimonialsSection } from './TestimonialsSection';
import { DOC_TITLE, content, type Lang } from './content';
import { ScrollTrigger } from './motion';
import { useReveal } from './useReveal';
import './landing.css';

export function LandingPage() {
  const { i18n } = useTranslation();
  const lang: Lang = i18n.language === 'en' ? 'en' : 'ar';
  const c = content[lang];
  const root = useRef<HTMLDivElement>(null);
  const [demoOpen, setDemoOpen] = useState(false);
  const openDemo = useCallback(() => setDemoOpen(true), []);
  const closeDemo = useCallback(() => setDemoOpen(false), []);

  useReveal(root, [lang]);

  useEffect(() => {
    document.title = DOC_TITLE[lang];
    ScrollTrigger.refresh();
    return () => {
      document.title = 'RFleet';
    };
  }, [lang]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, []);

  return (
    <div className="lp" ref={root} id="top">
      <BgFx />
      <SvgDefs />
      <div className="page">
        <Navbar c={c} onOpenDemo={openDemo} />
        <main>
          <HeroSection c={c} lang={lang} onOpenDemo={openDemo} />
          <Marquee c={c} />
          <FeaturesSection c={c} />
          <LiveTrackingShowcase c={c} onOpenDemo={openDemo} />
          <HowItWorks c={c} />
          <SolutionsSection c={c} />
          <RoiCalculator c={c} onOpenDemo={openDemo} />
          <CompareSection c={c} />
          <TestimonialsSection c={c} />
          <FaqSection c={c} />
          <CtaBanner c={c} onOpenDemo={openDemo} />
        </main>
        <Footer c={c} />
      </div>
      <DemoModal c={c} open={demoOpen} onClose={closeDemo} />
    </div>
  );
}

export default LandingPage;
